import React, {Component} from 'react';
import {Table, Button, DropdownButton, MenuItem} from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import avatar from '../../../../images/face-0.jpg';
import './styles.css';
import {personFullName} from '../../../../services/Api';
import redFinger from '../../images/fingerprint-red.png';
import greenFinger from '../../images/fingerprint-green.png';
import PropTypes from "prop-types";
import AnnuityPaymentFormModal from "../AnnuityPaymentFormModal";
import DeleteAnnuityPaymentModal from "../DeleteAnnuityPaymentModal";
import AnnuityPaymentDetailModal from "../AnnuityPaymentDetailModal";
import AddCongressModal from "../AddCongressAttendanceModal";
import AddDiplomaModal from "../AddEmittedCertificateModal";
import DeleteCongressAttendanceModal from "../DeleteCongressAttendanceModal";
import DeleteEmittedCertificateModal from "../DeleteEmittedCertificateModal";
import AddEventAttendanceModal from "../AddEventAttendanceModal";
import DeleteEventAttendanceModal from "../DeleteEventAttendanceModal";
import PermissionsAdmin from "./components/PermissionsAdmin";
import UnwantedIHSYearsAdmin from "./components/UnwantedIHSYearsAdmin";
import FileViewerModal from "../FileViewerModal";

class PersonDetail extends Component {

    static contextTypes = {api: PropTypes.object, security: PropTypes.object};

    state = {};

    sendWelcome = () => {
        this.setState({sendingWelcome: true});
        this.context.api.users.sendWelcome(this.props.person.user.email)
            .then(() => {
                this.setState({
                    recoverPassSuccess: true,
                    recoverPassError: false,
                    recoverPassDate: moment(),
                    sendingWelcome: false
                });
            })
            .catch(() => {
                this.setState({sendingWelcome: false});
            })
    };

    sendStatement = () => {
        this.setState({sendingStatement: true});
        this.context.api.people.sendStatement(this.props.person.id)
            .then(() => {
                this.setState({
                    recoverPassSuccess: true,
                    recoverPassError: false,
                    recoverPassDate: moment(),
                    sendingWelcome: false,
                    sendingStatement: false
                });
            })
            .catch(() => {
                this.setState({sendingWelcome: false, sendingStatement: false});
            })
    };

    /* ----- AnnuityPayments handling --------*/

    openAddPayment = () => this.setState({addingPayment: true});

    closeAddPayment = () => this.setState({addingPayment: false});

    onEditPayment = (e) => this.setState({editingPayment: e.currentTarget.dataset.index});

    closeEditPayment = () => this.setState({editingPayment: false});

    onDeletePayment = (e) => this.setState({deletingPayment: e.currentTarget.dataset.index});

    closeDeletePayment = () => this.setState({deletingPayment: false});

    deletePayment = (annuityPayment) => {
        const {onAnyChange} = this.props || {};
        this.context.api.annuityPayments.delete(annuityPayment.id).then(() => {
            this.context.api.people.refresh(this.props.person.id, "loadingId", "currentPerson");
            (onAnyChange) && onAnyChange();
        });
        this.closeDeletePayment();
    };

    onDeleteCongressAttendance = (e) => this.setState({deletingCongressAttendance: e.currentTarget.dataset.index});

    closeDeleteCongressAttendance = () => this.setState({deletingCongressAttendance: false});

    deleteCongressAttendance = (congressAttendance) => {
        this.context.api.congressAttendances.delete(congressAttendance.id)
            .then(() => this.context.api.people.refresh(this.props.person.id, "loadingId", "currentPerson")
            );
        this.closeDeleteCongressAttendance();
    };

    onDeleteEmittedCertificate = (e) => this.setState({deletingEmittedCertificate: e.currentTarget.dataset.index});

    onShowCertificate = (e) => {
        const emittedCertificate = this.props.person.emittedCertificates[e.currentTarget.dataset.index]
        const url = this.context.api.appFiles.getUrl(emittedCertificate.file.id)
        this.setState({showingCertificateUrl: url})
    };

    onHideCertificate = () => {
        this.setState({showingCertificateUrl: null});
    }


    onShowStatement = (e) => {
        console.log(e.currentTarget.dataset.url)
        //const emittedCertificate = this.props.person.emittedCertificates[e.currentTarget.dataset.index]
        //const url = this.context.api.appFiles.getUrl(emittedCertificate.file.id)
        this.setState({showingStatementUrl: e.currentTarget.dataset.url})
    };

    onHideStatement = () => {
        this.setState({showingStatementUrl: null});
    }


    closeDeleteEmittedCertificate = () => this.setState({deletingEmittedCertificate: false});

    deleteEmittedCertificate = (emittedCertificate) => {
        this.context.api.emittedCertificates.delete(emittedCertificate.id)
            .then(() =>
                this.context.api.people.refresh(this.props.person.id, "loadingId", "currentPerson"));

        this.closeDeleteEmittedCertificate()
    };

    onDetailPayment = (e) => this.setState({detailingPayment: e.currentTarget.dataset.index});

    closeDetailPayment = () => this.setState({detailingPayment: false});

    didEditPerson = () => {
        const {onAnyChange} = this.props || {};

        this.context.api.people
            .refresh(this.props.person.id, "loadingId", "currentPerson")
            .then(() => {
                (onAnyChange) && onAnyChange();
            });

        this.setState({addingPayment: false, editingPayment: false});
    };

    /* ----- END AnnuityPayments handling --------*/

    /*Adding diploma*/
    openAddEmittedCertificate = () => this.setState({addingEmittedCertificate: true});
    closeAddingEmittedCertificate = () => this.setState({addingEmittedCertificate: false});
    /*Adding congress*/
    openAddCongressAttendance = () => this.setState({addingCongressAttendance: true});
    closeAddingCongressAttendance = () => this.setState({addingCongressAttendance: false});

    /*--------- Event Attendance handling --------*/

    onDeleteEventAttendance = (e) => this.setState({deletingEventAttendance: e.currentTarget.dataset.index});

    closeDeleteEventAttendance = () => this.setState({deletingEventAttendance: false});

    deleteEventAttendance = (eventAttendance) => {
        this.context.api.eventAttendances.delete(eventAttendance.id)
            .then(() => this.context.api.people.refresh(this.props.person.id, "loadingId", "currentPerson"));
        this.closeDeleteEventAttendance();
    };
    openAddEventAttendance = () => this.setState({addingEventAttendance: true});
    closeAddingEventAttendance = () => this.setState({addingEventAttendance: false});

    render() {

        if (!this.props.person) return null;

        let photo;
        if (this.props.person.photo)
            photo = this.context.api.appFiles.getUrl(this.props.person.photo.id);

        let academicResumeFile;
        if (this.props.person.academicResume)
            academicResumeFile = this.context.api.appFiles.getUrl(this.props.person.academicResume.id);

        let registrationFile;
        if (this.props.person.membership && this.props.person.membership.registrationVoucher)
            registrationFile = this.context.api.appFiles.getUrl(this.props.person.membership.registrationVoucher.id);

        return (
            <div className='PersonDetail'>
                <div className='detail-header'>
                    <div className='user-photo' style={{backgroundImage: 'url(' + (photo || avatar) + ')'}}>
                        <img className='fingerprint'
                             src={this.props.person.fingerpirntRegistered ? greenFinger : redFinger} alt='fingerprint'/>
                    </div>
                    <h4>{this.props.person.title ? this.props.person.title : ''} {personFullName(this.props.person)}</h4>
                    {this.props.canDownloadCredential ?
                        <DropdownButton title="Descargar credencial" id='credential'>
                            <MenuItem
                                href={this.context.api.people.downloadCredentialUrl(this.props.person.id, 'front')}>Frente</MenuItem>
                            <MenuItem
                                href={this.context.api.people.downloadCredentialUrl(this.props.person.id, 'back')}>Revés</MenuItem>
                        </DropdownButton> : null
                    }
                </div>

                <br/>
                <div className='actions'>
                    <a href={this.context.api.people.downloadStatement(this.props.person.id)}>
                        <button className='btn btn-info btn-fill btn-magnify pull-left download-report'>
                            <span className='btn-label'>Descargar estado de cuenta</span>
                        </button>
                    </a>


                    {this.state.sendStatementSuccess ? <span>Correo enviado</span> :
                        this.state.sendingStatement ? <span>Enviando...</span> :
                            <button className='btn btn-info btn-fill btn-magnify pull-left download-report'
                                    onClick={this.sendStatement}>Enviar estado de cuenta</button>}

                    <button onClick={this.onShowStatement}
                            data-url={this.context.api.people.downloadStatement(this.props.person.id)}
                            className='btn btn-info btn-fill btn-magnify pull-left download-report'>
                        <span className='btn-label'>Ver estado de cuenta</span>
                    </button>
                    <div className='clearfix'></div>
                </div>
                <h4>Información</h4>
                <Table>
                    <tbody>
                    <tr>
                        <td>Fecha de nacimiento</td>
                        <td>{moment(this.props.person.birthDate).format('LL')}</td>
                    </tr>
                    {this.props.person.dateOfDeath &&
                        <tr>
                            <td>Fecha de defunción</td>
                            <td>{moment(this.props.person.dateOfDeath).format('LL')}</td>
                        </tr>
                    }
                    <tr>
                        <td>Email</td>
                        <td><a href={'mailto:' + this.props.person.email}>{this.props.person.email}</a></td>
                    </tr>
                    <tr>
                        <td>Teléfono fijo</td>
                        <td><a href={'tel:' + this.props.person.fixedPhone}>{this.props.person.fixedPhone}</a></td>
                    </tr>
                    <tr>
                        <td>Teléfono celular</td>
                        <td><a href={'tel:' + this.props.person.mobilePhone}>{this.props.person.mobilePhone}</a></td>
                    </tr>
                    <tr>
                        <td>Residencia</td>
                        <td>{this.props.person.residence}</td>
                    </tr>
                    {this.props.person.city ?
                        <tr>
                            <td>Ciudad</td>
                            <td>{this.props.person.city}</td>
                        </tr>
                        : null}
                    <tr>
                        <td>Código postal</td>
                        <td>{this.props.person.zipCode}</td>
                    </tr>
                    <tr>
                        <td>RFC</td>
                        <td>{this.props.person.rfc}</td>
                    </tr>
                    <tr>
                        <td>Régimen fiscal</td>
                        <td>{this.props.person.fiscalRegime ? this.props.person.fiscalRegime.name : 'Sin especificar'}</td>
                    </tr>
                    </tbody>
                </Table>


                {this.props.person.membership && this.props.canEdit ?
                    <UnwantedIHSYearsAdmin membership={this.props.person.membership}
                                           unwantedIHSYears={this.props.person.membership.unwantedIHSYears}
                                           onChange={this.didEditPerson}/>
                    : null}

                <h4>Anualidades</h4>
                {this.props.person.membership && this.props.person.membership.annuityPayments && this.props.person.membership.annuityPayments.length ?
                    <Table>
                        <tbody>
                        {this.props.person.membership.annuityPayments.map((payment, index) =>
                            <tr key={payment.id}>
                                <td>Anualidad {payment.type === 'membership' ? 'membresía' : 'IHS'} {payment.year}</td>
                                <td>Pagada el {moment(payment.paymentDate).format('DD/MM/YYYY')}</td>
                                <td>
                                    <button className='btn btn-xs btn-default' onClick={this.onDetailPayment}
                                            data-index={index}><i className='fa fa-eye'/></button>
                                    &nbsp;
                                    {this.props.canEdit ?
                                        <span>
                                                <button className='btn btn-xs btn-primary' onClick={this.onEditPayment}
                                                        data-index={index}><i className='ti-pencil'/></button>
                                            &nbsp;
                                            <button className='btn btn-xs btn-danger' onClick={this.onDeletePayment}
                                                    data-index={index}><i className='ti-trash'/></button>
                                            &nbsp;
                                    </span>
                                        : null}
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                    :
                    <p>Ninguna anualidad registrada</p>
                }
                {this.props.canEdit ?
                    <Button bsStyle='primary' onClick={this.openAddPayment}>Añadir pago</Button>
                    : null}

                <h4>Detalles profesionales</h4>
                <Table>
                    <tbody>
                    <tr>
                        <td>Título</td>
                        <td>{this.props.person.title}</td>
                    </tr>
                    <tr>
                        <td>Especialidad</td>
                        <td>{this.props.person.specialty ? this.props.person.specialty.name : ''}</td>
                    </tr>
                    <tr>
                        <td>Cédula profesional</td>
                        <td>{this.props.person.professionalLicense}</td>
                    </tr>
                    <tr>
                        <td>Número de certificación</td>
                        <td>{this.props.person.certificationNumber}</td>
                    </tr>

                    </tbody>
                </Table>

                {this.props.person.membership ?
                    <div>
                        <h4>Membresía</h4>
                        <Table>
                            <tbody>

                            <tr>
                                <td>Número de miembro</td>
                                <td>{this.props.person.membership.id}</td>
                            </tr>

                            <tr>
                                <td>Número de miembro IHS</td>
                                <td>{this.props.person.membership.ihsMemberNumber ? this.props.person.membership.ihsMemberNumber : "Sin membresía IHS"}</td>
                            </tr>

                            <tr>
                                <td>Tipo de miembro</td>
                                <td>{this.props.person.membership.type}</td>
                            </tr>

                            <tr>
                                <td>Miembro desde</td>
                                <td>{moment(this.props.person.membership.registrationDate).format('DD/MM/YYYY')}</td>
                            </tr>

                            {this.props.person.user && this.props.canEdit ?
                                <tr>
                                    <td>Fecha de envío de bienvenida y contraseña</td>
                                    <td>{this.state.recoverPassDate ? moment(this.state.recoverPassDate).format('DD/MM/YYYY h:mm a') :
                                        this.props.person.user.passwordSentDate ?
                                            moment(this.props.person.user.passwordSentDate).format('DD/MM/YYYY h:mm a') :
                                            "Nunca enviado"}
                                        <br/>
                                        {this.state.recoverPassSuccess ? <span>Correo enviado</span> :
                                            this.state.sendingWelcome ? <span>Enviando...</span> :
                                                <button className='btn btn-success btn-xs'
                                                        onClick={this.sendWelcome}>Reenviar correo</button>}

                                    </td>
                                </tr> : null}
                            </tbody>
                        </Table>

                        <h4>Congresos</h4>
                        {this.props.person.membership && this.props.person.membership.annuityPayments && this.props.person.congressAttendances.length ?
                            <Table>
                                <tbody>
                                {this.props.person.congressAttendances.map((congressAttendance, index) =>
                                    <tr key={congressAttendance.id}>
                                        <td>{congressAttendance.congress.name}</td>
                                        <td>{congressAttendance.congress.year}</td>
                                        <td>
                                            {this.props.canEdit ?
                                                <span>
                                                        <button className='btn btn-xs btn-danger'
                                                                onClick={this.onDeleteCongressAttendance}
                                                                data-index={index}><i className='ti-trash'/></button>
                                                    &nbsp;
                                                </span> : null}
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>
                            :
                            <p>Ningún congreso registrado</p>
                        }
                        {this.props.canEdit ?
                            <Button bsStyle='primary' onClick={this.openAddCongressAttendance}>Añadir Congreso</Button>
                            : null}


                        <h4>Constancias</h4>
                        {this.props.person.membership && this.props.person.membership.annuityPayments && this.props.person.emittedCertificates.length ?
                            <Table>
                                <tbody>
                                {
                                    this.props.person.emittedCertificates.map((emittedCertificate, index) => {
                                            return (
                                                <React.Fragment key={emittedCertificate.id}>
                                                    {
                                                        <tr>
                                                            <td>{emittedCertificate.certificate.name}</td>
                                                            <td>

                                                                {emittedCertificate.file !== null ?
                                                                    <a href={this.context.api.appFiles.getDownloadUrl(emittedCertificate.file.id)}
                                                                       rel='noopener'>{emittedCertificate.file.originalName}</a> : "Sin archivo"}
                                                            </td>
                                                            <td>
                                                                 <span>
                                                                            <button className='btn btn-xs btn-info'
                                                                                    onClick={this.onShowCertificate}
                                                                                    data-index={index}><i
                                                                                className='ti-eye'/></button>
                                                                     &nbsp;
                                                                        </span>
                                                            </td>
                                                            <td>
                                                                {
                                                                    this.props.canEdit ?
                                                                        <span>
                                                                            <button className='btn btn-xs btn-danger'
                                                                                    onClick={this.onDeleteEmittedCertificate}
                                                                                    data-index={index}><i
                                                                                className='ti-trash'/></button>
                                                                            &nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                            </td>
                                                        </tr>
                                                    }
                                                </React.Fragment>
                                            )
                                        }
                                    )
                                }
                                </tbody>
                            </Table>
                            :
                            <p>Ninguna constancia registrada</p>
                        }
                        {this.props.canEdit ?
                            <Button bsStyle='primary' onClick={this.openAddEmittedCertificate}>Añadir
                                Constancia</Button>
                            : null}

                        <h4>Asistencia a eventos y talleres</h4>
                        {this.props.person.membership && this.props.person.membership.annuityPayments && this.props.person.eventAttendances.length ?
                            <Table>
                                <tbody>
                                {this.props.person.eventAttendances.map((eventAttendance, index) =>
                                    <tr key={eventAttendance.id}>
                                        <td>{eventAttendance.event.name}</td>
                                        {eventAttendance.event.fromDate && eventAttendance.event.toDate && (moment(eventAttendance.event.fromDate).format('DD/MM/YYYY') !== moment(eventAttendance.event.toDate).format('DD/MM/YYYY')) ?
                                            <td>Del {moment(eventAttendance.event.fromDate).format('DD/MM/YYYY')} al {moment(eventAttendance.event.toDate).format('DD/MM/YYYY')}</td>
                                            : <td>{moment(eventAttendance.event.fromDate).format('DD/MM/YYYY')}</td>}
                                        <td>
                                            {this.props.canEdit ?
                                                <span>
                                                        <button className='btn btn-xs btn-danger'
                                                                onClick={this.onDeleteEventAttendance}
                                                                data-index={index}><i className='ti-trash'/></button>
                                                    &nbsp;
                                                </span>
                                                : null}
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>
                            :
                            <p>Ningún evento o taller registrado</p>
                        }
                        {this.props.canEdit ?
                            <Button bsStyle='primary' onClick={this.openAddEventAttendance}>Añadir evento o
                                taller</Button>
                            : null}
                    </div>
                    : null}

                {this.props.canEdit ?
                    <PermissionsAdmin person={this.props.person}/>
                    : null}

                <h4>Información pública de contacto</h4>
                <pre>
                    {this.props.person.contactData}
                </pre>

                {academicResumeFile ?
                    <h6><a href={academicResumeFile} target='_blank'>Ver información académica</a></h6>
                    : null}

                {registrationFile ?
                    <h6><a href={registrationFile} target='_blank'>Ver archivo de registro firmado</a></h6>
                    : null}

                {/*  New payment Modal */}
                {this.state.addingPayment ?
                    <AnnuityPaymentFormModal
                        onHide={this.closeAddPayment}
                        person={this.props.person}
                        type={undefined}
                        membership={this.props.person.membership}
                        didSave={this.didEditPerson}
                    />
                    : null}

                {this.state.showingCertificateUrl ?
                    <FileViewerModal
                        fileUrl={this.state.showingCertificateUrl}
                        onHide={this.onHideCertificate}
                    />
                    : null}

                {this.state.showingStatementUrl ?
                    <FileViewerModal
                        fileUrl={this.state.showingStatementUrl}
                        onHide={this.onHideStatement}
                    />
                    : null}

                {/*  Edit payment Modal */}
                {this.state.editingPayment ?
                    <AnnuityPaymentFormModal
                        onHide={this.closeEditPayment}
                        editing={this.props.person.membership.annuityPayments[this.state.editingPayment]}
                        person={this.props.person}
                        membership={this.props.person.membership}
                        didSave={this.didEditPerson}
                        type={this.props.person.membership.annuityPayments[this.state.editingPayment].type}
                    />
                    : null}

                {/* Delete payment Modal*/}
                {this.state.deletingPayment ?
                    <DeleteAnnuityPaymentModal
                        annuityPayment={this.props.person.membership.annuityPayments[this.state.deletingPayment]}
                        onHide={this.closeDeletePayment}
                        onConfirm={this.deletePayment}
                        person={this.props.person}
                        type={this.props.person.membership.annuityPayments[this.state.deletingPayment].type}
                    />
                    : null}

                {/* Delete congressAttendance Modal*/}
                {this.state.deletingCongressAttendance ?
                    <DeleteCongressAttendanceModal
                        congressAttendance={this.props.person.congressAttendances[this.state.deletingCongressAttendance]}
                        onHide={this.closeDeleteCongressAttendance}
                        onConfirm={this.deleteCongressAttendance}
                        person={this.props.person}
                    />
                    : null}

                {/* Delete emittedCertificate Modal*/}
                {this.state.deletingEmittedCertificate ?
                    <DeleteEmittedCertificateModal
                        emittedCertificate={this.props.person.emittedCertificates[this.state.deletingEmittedCertificate]}
                        onHide={this.closeDeleteEmittedCertificate}
                        onConfirm={this.deleteEmittedCertificate}
                        person={this.props.person}
                    />
                    : null}
                {/* Show payment detail Modal*/}
                {this.state.detailingPayment ?
                    <AnnuityPaymentDetailModal
                        annuityPayment={this.props.person.membership.annuityPayments[this.state.detailingPayment]}
                        urlCreator={this.context.api.appFiles.getUrl}
                        onHide={this.closeDetailPayment}
                        person={this.props.person}
                        membership={this.props.person.membership}
                        type={this.props.person.membership.annuityPayments[this.state.detailingPayment].type}
                    />
                    : null}

                {this.state.addingCongressAttendance ?
                    <AddCongressModal
                        onHide={this.closeAddingCongressAttendance}
                        person={this.props.person}
                        didSave={this.didEditPerson}
                    /> : null}

                {this.state.addingEmittedCertificate ?
                    <AddDiplomaModal
                        onHide={this.closeAddingEmittedCertificate}
                        person={this.props.person}
                        didSave={this.didEditPerson}
                    /> : null}

                {this.state.addingEventAttendance ?
                    <AddEventAttendanceModal
                        onHide={this.closeAddingEventAttendance}
                        person={this.props.person}
                        didSave={this.didEditPerson}
                    /> : null}

                {/* Delete eventAttendance Modal*/}
                {this.state.deletingEventAttendance ?
                    <DeleteEventAttendanceModal
                        eventAttendance={this.props.person.eventAttendances[this.state.deletingEventAttendance]}
                        onHide={this.closeDeleteEventAttendance}
                        onConfirm={this.deleteEventAttendance}
                        person={this.props.person}
                    />
                    : null}
            </div>
        );
    }
}

export default PersonDetail;



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/PersonDetail/index.js